export default {
  api: import.meta.env.VITE_API_URL,
  apiStudent: import.meta.env.VITE_API_STUDENT_URL,
  token: {
    secret: import.meta.env.VITE_SECRET,
  },
};
